import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import React from 'react';
import { SharedComponentVersion, VersionOption } from '../types';

interface VersionSelectorProps {
  selectedVersion: SharedComponentVersion;
  availableVersions: VersionOption[];
  onVersionChange: (version: SharedComponentVersion) => void;
}

export function VersionSelector({
  selectedVersion,
  availableVersions,
  onVersionChange,
}: VersionSelectorProps): React.JSX.Element {
  const handleChange = (event: SelectChangeEvent<SharedComponentVersion>) => {
    onVersionChange(event.target.value as SharedComponentVersion);
  };

  return (
    <FormControl fullWidth sx={{ maxWidth: 400 }}>
      <InputLabel id='version-select-label'>Select Version</InputLabel>
      <Select
        labelId='version-select-label'
        id='version-select'
        value={selectedVersion}
        label='Select Version'
        onChange={handleChange}
      >
        {availableVersions.map((version) => (
          <MenuItem key={version.value} value={version.value}>
            {version.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
